import React, { Component } from 'react';

class BreadCrumb extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="breadcrumb-bar">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-4 col-12">
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Quality Control
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        QC Ranges
                                    </li>
                                </ol>
                            </nav>
                            <h2 className="breadcrumb-title">QC Ranges</h2>
                        </div>
                        <div className="col-md-8 col-12">
                            <div className="row breadcrumb-btns">
                                <label className="breadcrumb-text">QC Sample Creation:</label>
                                <ul className="export-ul">
                                    <li onClick={() => this.props.onBtnBulkSelect()}>
                                        {this.props.isBulkSelect ? 'Disable' : 'Enable'} Selection
                                    </li>
                                    {this.props.showCreateButton && (
                                        <li onClick={() => this.props.onBtnCreateQcSample()}>Create</li>
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BreadCrumb;
